import React from 'react';
import { Handle, Position, NodeProps } from '@xyflow/react';
import { PhoneOff, Trash2 } from 'lucide-react';
import { cn } from '../../../lib/utils';
import { useWorkflowStore } from '../store';

export function EndNode({ id, selected }: NodeProps) {
  const setNodes = useWorkflowStore(state => state.setNodes);
  const setEdges = useWorkflowStore(state => state.setEdges);
  const nodes = useWorkflowStore(state => state.nodes);
  const edges = useWorkflowStore(state => state.edges);
  
  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    setNodes(nodes.filter(n => n.id !== id));
    setEdges(edges.filter(e => e.source !== id && e.target !== id));
  };

  return (
    <div
      className={cn(
        "group relative flex flex-col rounded-xl border bg-elevated text-left shadow-sm hover:shadow-md transition-all duration-200",
        selected ? "border-danger ring-2 ring-danger/20" : "border-line",
      )}
      style={{ width: 200, height: 80 }}
    >
      <Handle type="target" position={Position.Top} className="w-3 h-3 bg-ink-3" />
      
      <div className="flex h-10 items-center justify-between border-b border-line px-3 bg-danger-soft/40 rounded-t-xl">
        <div className="flex items-center gap-2">
          <PhoneOff className="h-4 w-4 text-danger" />
          <span className="font-semibold text-ink text-sm">End Call</span>
        </div>
        
        <button 
          onClick={handleDelete}
          className="opacity-0 group-hover:opacity-100 p-1 text-ink-3 hover:text-danger hover:bg-danger-soft rounded transition-all"
        >
          <Trash2 className="h-3.5 w-3.5" />
        </button>
      </div>

      <div className="flex flex-1 items-center px-3 text-xs text-ink-3">
        Closes the conversation and hangs up
      </div>
    </div>
  );
}
